
import React, { useState, useEffect, useContext } from "react";


import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
// import Sidebar from "../components/dashboard/sidebar";/
import SideMenu from "../student/SideMenu";
import Loader from "../../components/loader";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../../api/tmdbApi";
import moment from "moment";

import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from '../../context/contentContext'

import TableLoader from "../../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';


import { ToastContainer } from "react-toastify";

import { toast } from "react-toastify";

let { lambda, appname } = window.app

const EmailManager = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");

    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);

    // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);

    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    // const [sortDirection, setSortDirection] = useState('asc');
    const [deleteShow, setDeleteShow] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(false);
    const [deleteSuccess, setDeleteSuccess] = useState(false);

    let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);

    // const [isLoading, setIsLoading] = useState(false); 
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity, isRestricted } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "Users")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setSearchedFlag(false);
            setUserSearch("")
        }
    }, [prevRoute]);
     useEffect(() => {
            if (!localStorage.getItem("token")) {
                navigate("/");
            }
            // getHistory();
          
        }, []);
    //  console.log('prevRoute--->',prevRoute)
    //  console.log('currentRoute--->',route)
    const keyForRerender = `${rowsPerPage}_${data?.length}`;
    const columns = [

        {
            name: 'Subject Line',
            selector: row => row?.subjectline ?? "",
            sortable: true,
        },
         {
            name: 'From Email',
            selector: row => Array.isArray(row?.fromEmailAddress) ? row.fromEmailAddress.join(', ') : (row?.fromEmailAddress ?? ""),
            sortable: true,
        },
        {
            name: 'To Email',
            selector: row => Array.isArray(row?.toemailid) ? row.toemailid.join(', ') : (row?.toemailid ?? ""),
            sortable: true,
        },
        {
            name: 'Sent on',
            selector: row => row?.senton,
            sortable: true,
            cell: (props) => props?.senton ? dateFormat(props?.senton) : "",
            // sortFunction: (a, b) => moment(a.created).diff(b.created),
        },
        {
            name: 'Status',
            selector: row => row?.status ?? "",
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (props) =>
                <div className="d-flex">
                    <a onClick={(e) => handleViewEmailLog(e, props.logid)}
                        className='text-success action-button'><i
                            className="mdi mdi-eye font-size-18"></i>  </a>
                </div>,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const dateFormat = (created) => {
        const date = new Date(created);
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const year = String(date.getUTCFullYear()).slice(-2);

        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');

        return `${day}-${month}-${year} ${hours}:${minutes}`;
    }

    const handlePageChange = (page) => {
        GetTimeActivity()
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage) => {
        GetTimeActivity()
        setRowsPerPage(newPerPage);
    };


    useEffect(() => {
        setRoute("user")
        // setActiveMenuId(200003)
        setData([])
        // userActivity();
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
    }, []);

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = path[path.length - 1];
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };

    }


    useEffect(() => {
        if (searchedFlag) {
            handleSearch();
        } else {
            User();
        }

    }, [searchedFlag]);

    const PageLoad = (e) => {
        const pagevalue = e.target.value;
        //setPerpage(pagevalue);
        setitemsPerPage(pagevalue);
        setcurrentPage(1);
        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);

    }


    const User = (e) => {
        setIsLoading(true)
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/emailhistory?appname=' + appname +  '&userid=' + localStorage.getItem("userId") + '&token=' + token,
        })
            .then(function (response) {
                console.log("response", response);
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                    //                   localStorage.clear();
                    //    navigate("/")
                } else {
                    const result = Array.isArray(response?.data?.result?.data) ? response.data.result.data : [];
                    setUser(result);
                    setData(result);
                    global.exportExcelData = result



                    setIsLoading(false);
                    setUserSearch("");
                    setSearchedFlag(false);
                }
            }).catch((err) => {
                console.log('error', err);
                setTableErrMsg(true)
                setIsLoading(false);
            });
    }




    const handleSearch = (e, flagggg) => {
        GetTimeActivity();

        const inputQuery = usersearch;

        // ✅ Show error ONLY when user clicks Search / presses Enter
        if (flagggg === "normalsearch" && inputQuery.trim().length === 0) {
            toast.error("Search field cannot be empty.");
            return;
        }

        if (flagggg) {
            setcurrentPage(1);
        }

        setmaxPageNumberLimit(5);
        setminPageNumberLimit(0);

        if (flagggg === "normalsearch") {
            setSearchedFlag(true);
        }

        setFlag(true);

        // 🔁 Reset case (clear search)
        if (inputQuery === "") {
            User();
            return;
        }

        setIsLoading(true);

        const token = localStorage.getItem("token");

        axios({
            method: "GET",
            url:
                lambda +
                "/emailhistory?appname=" +
                appname +
                "&search=" +
                encodeURIComponent(inputQuery),
        })
            .then((response) => {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true);
                } else {
                    console.log("hh",response?.data?.result)
                    const result = Array.isArray(response?.data?.result?.data) ? response.data.result.data : [];
                    setUser(result);
                    setData(result);
                    global.exportExcelData = result;
                    setIsLoading(false);
                }
            })
            .catch((err) => {
                console.log("error", err);
                setTableErrMsg(true);
                setIsLoading(false);
            });
    };


    const handleChange = (e) => {
        if (e.target.value === "") {
            //   User();
            setFlag(false)
        }
        setUserSearch(e.target.value)
    }



    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        GetTimeActivity()
        if ((e.key === "Enter")) {
            setTimeout(function () {
                handleSearch();
            }, 1000);
        }
    };
    const handleBack = (e) => {
        navigate("/sendEmail");
    }

    const handleEditUser = (e, paramuserid) => {
        console.log('paramuserid', paramuserid)
        navigate("/edituser/" + paramuserid);
    }

    const handleDeleteUser = (e, paramuserid) => {
        setDeleteUserId(paramuserid)
        setDeleteShow(true)
    }

    const onDeleteCancel = (e) => {
        setDeleteShow(false)
        setDeleteUserId(null)

    }

    const onDeletePopupClose = (e) => {
        setDeleteSuccess(false)
        setDeleteUserId(null)
        User()
    }

    const handleDelete = async (e) => {
        setDeleteShow(false)
        try {
            await tmdbApi.userDelete(deleteUserId);

            setDeleteSuccess(true)
        } catch {
            console.log("error");
        }
    }


    const handleViewUser = (e, paramuserid) => {
        GetTimeActivity()

        navigate("/viewuser/" + paramuserid);
    }

    const handleViewEmailLog = (e, logid) => {
        GetTimeActivity()

        navigate("/viewemailtemplate/" + logid);
    }

    const clearSearch = () => {
        GetTimeActivity()
        setUserSearch("");
        User();
        setcurrentPage(1);
    }

    const customNoRecords = () => {
        return (

            <div className="empty-state-body empty-record"  >
                <div className="empty-state__message">
                    <span className="material-icons">summarize</span>
                    <p className="form-check font-size-16">No data were found</p>
                </div> </div>
        )
    }
    const handleExport = () => {

        // let k = defaultData || exportExcelData
        const modifiedArray = global.exportExcelData.map((each, i) => ({
            "S.NO": i + 1,
            "NAME": each?.name ?? "",
            "USER TYPE": each?.userType ?? "",
            "EMAIL ID": typeof each?.emailid === "object" && each?.emailid !== null && each?.emailid.length > 1 ? each?.emailid.join(', ') : each?.emailid ?? "",
            "PHONE NUMBER": each?.phone ?? "",
            "STATUS": each?.status ?? "",

        }));

        exportToExcel(modifiedArray, "data");

    }
    function exportToExcel(jsonData, fileName) {
        delete jsonData['_id'];
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const data1 = new Blob([excelBuffer], { type: 'application/octet-stream' });
        //FileSaver.saveAs(data, `${fileName}.xlsx`);
        FileSaver.saveAs(data1, `UsersData.xlsx`);
        console.log('data22222--->', data)
    }
    const customSort = (rows, selector, direction) => {
        const sortedData = (Array.isArray(rows) ? rows : []).slice().sort((rowA, rowB) => {
            // use the selector function to resolve your field names by passing the sort comparators
            // const aField = selector(rowA);
            const aField = String(selector(rowA)).toLowerCase();

            //  const bField = selector(rowB);
            const bField = String(selector(rowB)).toLowerCase();

            let comparison = 0;

            if (aField > bField) {
                comparison = 1;
            } else if (aField < bField) {
                comparison = -1;
            }

            return direction === 'desc' ? comparison * -1 : comparison;
        });

        // Log the sorted data to the console
        // setSortedRecomData(sortedData)
        global.exportExcelData = sortedData
        // console.log('Sorted Data------>:', sortedData);

        return sortedData;
    };
     console.log("data",data,user)
    return (
        <>

            <div id="layout-wrapper" className="users-mod-res">
                <Header />
                <SideMenu />

                {/* Start right Content here  */}

                <div className="main-content user-management" id="main-content">
                    <div className="page-content" id="page-content">
                        <div className="container-fluid" id="container-fluid">

                            <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                <div className="col-lg-12">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h4 className="mb-2 card-title" id="breadcrumb-title">EMAIL HISTORY</h4>
                                        </div>

                                        <div>

                                            <button className="btn btn-primarys create-quiz-btn" onClick={handleBack}

                                                disabled={isRestricted} id="add-user-btn">
                                              Back
                                            </button>
                                        </div>


                                    </div>
                                </div>
                            </div>

                            <div className="row table-data" id="table-data-row">
                                <div className="col-12">
                                    <div className="card" id="card">
                                        <div className="card-body" id="card-body">
                                            {isLoading ? <Loader /> : <>
                                                <div className="row mb-2" id="table-header-row">
                                                    <div className="col-sm-4 button-block" id="button-block">
                                                        <div className="dataTables_length" id="datatable-length">

                                                            {/* <button className={`fill_btn ${data.length <= 0 ||subValDashboard.export.enable === false ? 'disable pe-none' : ''}`} 
                          onClick={handleExport} id="export-btn">
                          <span className="material-icons">north_east</span>Export
                      </button> */}


                                                        </div>
                                                    </div>
                                                    <div className="col-sm-8">
                                                        <div className="search-box mb-2 d-inline-block" id="search-box">
                                                            {/* <div className="position-relative">
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={usersearch}
                                                                    onChange={(e) => handleChange(e)}
                                                                    placeholder="Search by Name or Email"
                                                                    onKeyPress={handleKeypress}
                                                                    id="search-input"
                                                                />
                                                                <button
                                                                    className="fill_btn"
                                                                    onClick={(e) => handleSearch(e, "normalsearch")}
                                                                    id="search-btn">
                                                                    <span className="material-icons search-icon">search</span>
                                                                </button>
                                                            </div> */}
                                                            {/* <div className="dataTables_length" id="datatable-length-reset">
                                                                <button
                                                                    className="fill_btn"
                                                                    onClick={clearSearch}
                                                                    id="reset-btn">
                                                                    <span className="material-icons-outlined">sync</span>Reset
                                                                </button>
                                                            </div> */}
                                                        </div>
                                                        <div className="text-sm-end" id="text-end"></div>
                                                    </div>
                                                </div>

                                                <DataTable
                                                    key={keyForRerender}
                                                    columns={columns}
                                                    keyField='_id'
                                                    data={data}
                                                    direction="auto"
                                                    highlightOnHover
                                                    fixedHeaderScrollHeight="300px"
                                                    pagination
                                                    responsive
                                                    persistTableHead
                                                    striped
                                                    subHeaderAlign="right"
                                                    defaultSortField="name"
                                                    noDataComponent={customNoRecords()}
                                                    paginationTotalRows={data?.length}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    paginationPerPage={rowsPerPage}
                                                    paginationDefaultPage={currentPageNew}
                                                    paginationRowsPerPageOptions={[15, 25, 50, 75, 100]}
                                                    sortFunction={customSort}
                                                    paginationComponentOptions={{
                                                        rowsPerPageText: 'Per page:',
                                                        rangeSeparatorText: 'of',
                                                        noRowsPerPage: false,
                                                        selectAllRowsItem: false,
                                                        selectAllRowsItemText: 'All',
                                                    }}
                                                    progressPending={isLoading}
                                                    progressComponent={<TableLoader />}
                                                    id="data-table"
                                                />
                                            </>}


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                        id="error-alert"
                    ></SweetAlert>


                    <SweetAlert
                        show={deleteShow}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure you want to delete?"
                        focusCancelBtn
                        onConfirm={e => handleDelete(e)}
                        onCancel={e => onDeleteCancel(e)}
                    >
                    </SweetAlert>

                    <SweetAlert show={deleteSuccess}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Deleted Successfully"}
                        onConfirm={e => onDeletePopupClose(e)}
                    >
                    </SweetAlert>
                    {/* ✅ Toast container should be here */}
                    <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        pauseOnHover
                        draggable
                    />

                    <Footer id="footer" />
                </div>




            </div>
        </>
    );
};

export default EmailManager;